import { theme, darkTheme } from './theme/themeVariables';

const config = {
  darkMode: false,
  topMenu: true,
  rtl: false,
  theme,
  darkTheme,
  auth0: false,
  apiDomain: 'http://localhost:8081/api',
};

export default config;
